import React from "react";
import styled from "styled-components";
import { Card } from "storybook-components/Card";
import { H4, EyebrowSm } from "storybook-components/Typography";

const StyledLink = styled.a`
  width: 272px;
  display: flex;
  text-decoration: none;
  padding: 8px;
  width: 100%;
  ${({ theme }) => theme.media.tabletUp`
    width: calc(100% / 3);
  `};
`;

const TextContainer = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
  ${({ theme }) => theme.media.tabletUp`
    margin: 0;
  `};

  .body-wrapper {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 8px;
    min-height: 120px;
  }
`;

const HeroContainer = styled.div`
  margin-bottom: 12px;
  width: 100%;
`;

const StyledCard = styled(Card)`
  max-height: 200px;
  border-radius: 10px;
  transition: color 0.1s ease-out, background-color 0.1s ease-out;
  color: ${({ theme }) => theme.colors.green5};
  &:hover {
    color: ${({ theme }) => theme.colors.green5};
    background-color: ${({ theme }) => theme.colors.green2};
    color: 0 12px 40px 8px #19192544;
  }
  max-height: 200px;
  ${({ theme }) => theme.media.tabletUp`
    max-height: unset;
  `};
  ${({ theme }) => theme.media.desktopUp`
    max-height: 200px;
  `};
`;

const StyledEyebrowSm = styled(EyebrowSm)`
  margin: 0;
  color: ${({ theme }) => theme.colors.green5};
`;

const StyledH4 = styled(H4)`
  color: ${({ theme }) => theme.colors.green5};
  margin: 0;
  overflow: hidden;
`;

const TypeContainer = styled.div`
  display: flex;
`;

const HubCardLink = ({ link }) => {
  const { to, name, type, target } = link;
  return (
    <StyledLink href={to} target={target || "_self"}>
      <StyledCard>
        <HeroContainer>
          <TypeContainer>
            <StyledEyebrowSm>{type}</StyledEyebrowSm>
          </TypeContainer>
        </HeroContainer>
        <TextContainer>
          <div className="body-wrapper">
            <StyledH4 bold>{name}</StyledH4>
          </div>
        </TextContainer>
      </StyledCard>
    </StyledLink>
  );
};

export default HubCardLink;
